module.exports = "#born-date-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 0 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/registration/born-date/born-date.component.less
// module id = 522
// module chunks = 0